import PropTypes from '~/lib/propTypes'
import { Card, color, device, H2, radius, shadow, space } from '@ticketswap/solar'
import { CalendarDay, CalendarWeekend, Event } from '@ticketswap/solar/icons'
import styled from '@emotion/styled'
import { track } from '~/utils/analytics'
import Link from 'next/link'
import { RouteMap } from '~/lib/routeMap'
import { BROWSE_EVENTS_CLICKED } from '~/lib/tracking-events'

const StyledH2 = styled(H2)`
  margin-block-end: ${space[8]};
`

const StyledLink = styled.a`
  display: block;
  cursor: pointer;

  :not(:last-of-type) {
    margin-block-end: ${space[8]};
  }

  div,
  h4,
  h5 {
    word-break: normal;
    white-space: normal;
  }

  header {
    align-self: start;
  }
`

const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.lightForeground};
  background-color: ${props => props.bgColor};
  width: 2.5rem;
  height: 2.5rem;
  border-radius: ${radius.md};

  svg {
    filter: drop-shadow(${shadow.text});
  }

  .icon {
    transform: scale(0.75);
  }

  @media ${device.tablet} {
    width: ${space[48]};
    height: ${space[48]};

    .icon {
      transform: scale(1);
    }
  }
`

const BrowseButtons = ({ t }) => (
  <>
    <StyledH2>{t('home:browse.title')}</StyledH2>

    <Link
      prefetch={false}
      href={{
        pathname: RouteMap['BROWSE'],
        query: {
          period: 'today',
        },
      }}
      passHref
    >
      <StyledLink onClick={() => track(BROWSE_EVENTS_CLICKED, { filterName: 'today' })}>
        <Card
          title={t('home:browse.today.title')}
          subtitle={t('home:browse.today.subtitle')}
          leftAdornment={
            <IconContainer bgColor={color.sun}>
              <CalendarDay />
            </IconContainer>
          }
        />
      </StyledLink>
    </Link>
    <Link
      prefetch={false}
      href={{
        pathname: RouteMap['BROWSE'],
        query: {
          period: 'this-weekend',
        },
      }}
      passHref
    >
      <StyledLink onClick={() => track(BROWSE_EVENTS_CLICKED, { filterName: 'thisWeekend' })}>
        <Card
          title={t('home:browse.thisWeekend.title')}
          subtitle={t('home:browse.thisWeekend.subtitle')}
          leftAdornment={
            <IconContainer bgColor={color.titan}>
              <CalendarWeekend />
            </IconContainer>
          }
        />
      </StyledLink>
    </Link>
    <Link
      prefetch={false}
      href={{
        pathname: RouteMap['BROWSE'],
      }}
      passHref
    >
      <StyledLink onClick={() => track(BROWSE_EVENTS_CLICKED, { filterName: 'noFilter' })}>
        <Card
          title={t('home:browse.other.title')}
          subtitle={t('home:browse.other.subtitle')}
          leftAdornment={
            <IconContainer bgColor={color.mars}>
              <Event />
            </IconContainer>
          }
        />
      </StyledLink>
    </Link>
  </>
)

BrowseButtons.propTypes = {
  t: PropTypes.func.isRequired,
}

export default BrowseButtons
